/** Public shipment identity; never substitute an unrelated entity number. */
export function shipmentReference(number?: number | null): string {
  return number != null && number > 0
    ? `SHP-${number}`
    : "Shipment reference unavailable";
}
